import createCache from "@emotion/cache";

/** Placeholder nginx replaces with $request_id; ignore in Vite local (no CSP). */
const PLACEHOLDER = "CSP_NONCE";

export function readCspNonce(): string | undefined {
    if (typeof document === "undefined") return undefined;
    const value = document.querySelector('meta[property="csp-nonce"]')?.getAttribute("content")?.trim();
    if (!value || value === PLACEHOLDER) return undefined;
    return value;
}

/** Shared Emotion cache so react-select / MUI <style> tags get the CSP nonce. */
export const emotionCache = createCache({
    key: "css",
    nonce: readCspNonce(),
    prepend: true,
});
